import React from 'react'
import injectStyles from 'react-jss'
import AxisLabel from './AxisLabel'

const styles = {
  axisLabelsContainer: {
    position: 'relative',
    height: 16,
    color: '#6d6d6d',
  },
  axisLabel: {
    position: 'absolute',
    top: 5,
  },
  innerAxisLabel: {
    position: 'relative',
  },
}

/**
 * @typedef AxisLabel
 * @property {string} label The axis label
 * @property {number} percent The positioning of this label a.k.a 50 is half
 * way along the container
 * @property {string} innerClassName Provide this if you need to re-style
 * the inner span. NOTE: At the time of writing this is only enabled on the
 * axistLables2 prop of the AxisLabels component, if you need it elsewhere
 * you'll have to update the code.
 *
 * @typedef AxisLabelsProps
 * @property {Array<AxisLabel>} axisLabels
 * @property {Array<AxisLabel>} axisLabels2
 * @property {Array<AxisLabel>} axisLabels3
 *
 * @param {AxisLabelsProps} props
 */
const AxisLabels = props => {
  const { classes, axisLabels, axisLabels2, axisLabels3 } = props
  return (
    <div className={classes.axisLabelsContainer}>
      {(axisLabels || []).map(({ label, percent }) => {
        return <AxisLabel label={label} percent={percent} />
      })}
      {(axisLabels2 || []).map(({ label, percent, innerClassName }) => {
        return (
          <AxisLabel
            label={label}
            percent={percent}
            type2
            innerClassName={innerClassName}
          />
        )
      })}
      {(axisLabels3 || []).map(({ label, percent }) => {
        return <AxisLabel label={label} percent={percent} type3 />
      })}
    </div>
  )
}

export default injectStyles(styles)(AxisLabels)



// WEBPACK FOOTER //
// ./src/Components/Stats/BulletChartRaw/AxisLabels.js